import { render, staticRenderFns } from "./ProductListMods.vue?vue&type=template&id=7c9a18b3&scoped=true"
import script from "./ProductListMods.vue?vue&type=script&lang=ts"
export * from "./ProductListMods.vue?vue&type=script&lang=ts"
import style0 from "./ProductListMods.vue?vue&type=style&index=0&id=7c9a18b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9a18b3",
  null
  
)

export default component.exports